// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1m5ZF","title":"BackImages_title__1jOcL","images":"BackImages_images__2IZda"};